import React from 'react';
import MainVideoTestimonial from 'src/components/Bootcamp/Testimonials/MainVideoTestimonial';
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';

const VideoSection = ({
  title,
  subtitle,
  videoThumbnail,
  videoLink,
  backgroundColor = colors.lightGrey,
}) => {
  return (
    <section
      css={{
        padding: '5rem 2rem',
        backgroundColor,
        [mediaQueries.phoneOnly]: {
          padding: '3rem 1rem',
        },
      }}
    >
      <div
        css={{
          maxWidth: 1200,
          margin: '0 auto',
        }}
      >
        <h2
          css={{
            textAlign: 'center',
            fontSize: '2.5rem',
            marginBottom: '1rem',
            color: colors.purpleDark,
            fontWeight: 700,
            [mediaQueries.phoneOnly]: {
              fontSize: '1.75rem',
            },
          }}
        >
          {title}
        </h2>

        {subtitle && (
          <p
            css={{
              textAlign: 'center',
              fontSize: '1.25rem',
              color: colors.darkGrey,
              marginBottom: '3rem',
              maxWidth: 800,
              marginLeft: 'auto',
              marginRight: 'auto',
              lineHeight: 1.6,
              [mediaQueries.phoneOnly]: {
                fontSize: '1rem',
                marginBottom: '2rem',
              },
            }}
          >
            {subtitle}
          </p>
        )}

        <div
          css={{
            maxWidth: 800,
            margin: '0 auto',
          }}
        >
          <MainVideoTestimonial mainThumbnail={videoThumbnail} link={videoLink} />
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
